module.exports = __webpack_public_path__ + "img/about_a03.12e12545.svg";